__webpack_require__.p = "/wp-content/themes/jelvix/block-version/build/";